__webpack_require__.p = "https://my.technovationchallenge.org/packs/";